
import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_BASE;

// console.log("REACT_APP_API_BASE =", API_BASE);

const api = axios.create({
  baseURL: `${API_BASE}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
